import { useCallback } from 'react';
import { useAsyncRequest } from '../../../../../../hooks';
import { get } from '../../../../../../redux/api';
import type { PendingDomainToken } from '../../../../../../../typings/api';

const usePendingDomains = (organizationId: number) => {
  const request = useCallback(() => {
    return get<PendingDomainToken[]>(`/api/organizations/${organizationId}/pending-sso-domains`);
  }, [organizationId]);

  return useAsyncRequest<PendingDomainToken[]>(request);
};

export default usePendingDomains;
